/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateExportJobRequest } from '../../models/create-export-job-request';
import { ExportJobDto } from '../../models/export-job-dto';

export interface ExportsPost$Plain$Params {
      body?: CreateExportJobRequest
}

export function exportsPost$Plain(http: HttpClient, rootUrl: string, params?: ExportsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportJobDto>> {
  const rb = new RequestBuilder(rootUrl, exportsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportJobDto>;
    })
  );
}

exportsPost$Plain.PATH = '/exports';
